// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ui_AP","footer":"Form_footer__2LPuk"};